export const blur = {}